import script from "./ColorTravelMap.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorTravelMap.vue?vue&type=script&setup=true&lang=js"

import "./ColorTravelMap.vue?vue&type=style&index=0&id=08a9c623&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08a9c623"]])

export default __exports__